import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>Revive Wellness Center</h3>
          <p>Nourishing your body, mind, and soul with natural goodness.</p>
        </div>
        <div className="footer-section">
          <h3>Hours</h3>
          <p>Monday-Friday: 7am - 8pm</p>
          <p>Saturday-Sunday: 8am - 7pm</p>
        </div>
        <div className="footer-section">
          <h3>Contact</h3>
          <p>123 Wellness Way</p>
          <p>Healthy City, HC 12345</p>
          <p>Phone: (555) 123-4567</p>
          <p>Email: info@revivewellness.com</p>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Revive Wellness Center. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;